import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7 mt-2" }, "请用英文逗号「,」隔开多个账号", -1)

import { ref } from "vue";
import TradeServices from "../services/TradeServices";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcludedAccountsModal',
  emits: ["saved"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = i18n.global;



const dialogVisible = ref(false);
const isLoading = ref(false);
const isSaving = ref(false);
const inputValue = ref("");

const parseAccounts = () =>
  Array.from(
    new Set(
      inputValue.value
        .split(/[\s,]+/)
        .map((item) => item.trim())
        .filter((item) => item !== "")
        .map((item) => Number(item))
        .filter((item) => Number.isInteger(item) && item > 0)
    )
  );

const fetchAccounts = async () => {
  isLoading.value = true;
  try {
    const res = await TradeServices.getExcludeProfitLossAccounts();
    inputValue.value = (res?.accounts ?? []).join(",");
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const save = async () => {
  isSaving.value = true;
  try {
    const accounts = parseAccounts();
    const res = await TradeServices.updateExcludeProfitLossAccounts(accounts);
    inputValue.value = (res?.accounts ?? accounts).join(",");
    MsgPrompt.success(t("tip.updateSuccess"));
    emits("saved");
    hide();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSaving.value = false;
  }
};

const show = async () => {
  inputValue.value = "";
  dialogVisible.value = true;
  await fetchAccounts();
};

const hide = () => {
  dialogVisible.value = false;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Excluded Accounts",
    width: "600px",
    "align-center": "",
    "append-to-body": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: hide,
        disabled: isSaving.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: isSaving.value,
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_input, {
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
          type: "textarea",
          rows: 5,
          placeholder: _ctx.$t('fields.accountNo'),
          clearable: ""
        }, null, 8, ["modelValue", "placeholder"]),
        _hoisted_1
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})